import { chromeDark, chromeLight } from "react-inspector";

export const lightInspectorTheme = {
  ...chromeLight,
  BASE_BACKGROUND_COLOR: "transparent",
  OBJECT_NAME_COLOR: "rgba(0,0,0,0.7)",
} as any;

export const darkInspectorTheme = {
  ...chromeDark,
  BASE_BACKGROUND_COLOR: "transparent",
  OBJECT_NAME_COLOR: "rgba(255,255,255,0.7)",
} as any;

export const getStateInspectorTheme = (colorScheme: "light" | "dark") => {
  return colorScheme === "light" ? lightInspectorTheme : darkInspectorTheme;
};

export const getStateInspectorBorderColor = (colorScheme: "light" | "dark") => {
  return colorScheme === "light" ? "rgb(223 223 223)" : "rgb(29 29 29)";
};
